<template>
  <div id="stockChart" :style="{ width: '100%', height: '600px',margin: '30px auto' }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'StockAnalysisChart',
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  watch: {
    stockData: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.updateChart();
        }
      },
      deep: true
    },
    agency: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.updateChart();
        }
      }
    },
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById('stockChart');
      if (chartDom) {
        this.chart = echarts.init(chartDom);
        this.updateChart();

        // 监听图表的点击事件
        this.chart.on('click', (params) => {
          if (params.componentType === 'series') {
            const stock = this.stockData[params.dataIndex];
            const url = `/stock-detail?stock_code=${stock['0']}`; // 假设这是你要跳转的URL
            window.open(url, '_blank');
          }
        });
      }
    },
    updateChart() {
      if (!this.chart || !this.stockData.length) return;
      const labels = this.stockData.map(stock => `${stock['0']}\n ${stock['1']}\n ${stock['3']}`);
      const buyData = this.stockData.map(stock => (stock['4'] || 0)); // 默认值为 0
      const sellData = this.stockData.map(stock => (stock['5'])); // 默认值为 0
      const sellData1 = this.stockData.map(stock => (stock['6'])); // 默认值为 0
      const upResonseData = this.stockData.map(stock => (stock['7'])); // 默认值为 0
      const upData8 = this.stockData.map(stock => (stock['8'])); // 默认值为 0
      const upData9 = this.stockData.map(stock => (stock['9'])); // 默认值为 0
      const upData10 = this.stockData.map(stock => (stock['10'])); // 默认值为 0
      const upData11 = this.stockData.map(stock => (stock['11'])); // 默认值为 0
      const option = {
          title:{
            text:this.agency,
            //subtext:this.agency,
          },
            tooltip: {
              trigger: 'item',
              axisPointer: {
                type: 'shadow'
              },
              formatter: (params) => {
                if (params.length === 0) {
                  return '无数据';
                }
                 let tooltipText = upResonseData[params.dataIndex];
                 tooltipText += "<br/>榜1:"+upData8[params.dataIndex]+'%';
                 tooltipText += "<br/>榜2:"+upData9[params.dataIndex]+'%';
                 tooltipText += "<br/>榜3:"+upData10[params.dataIndex]+'%';
                 tooltipText += "<br/>榜4:"+upData11[params.dataIndex]+'%';

                return tooltipText;
              }
            },
        legend: {
          data: ['买入金额占比', '卖出金额占比','剩余金额占比']
        },
        xAxis: [{
          type: 'category',
          data: labels,
           axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '买入金额占比',
            type: 'bar',
            data: buyData,
            label: {
              show: true,
              position: 'top',
              formatter: function (value) {
                if (typeof value.value === 'number' && !isNaN(value.value)) {
                  return value.value + '万元';
                } else {
                  return 'N/A';
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          },
          {
            name: '卖出金额占比',
            type: 'bar',
            data: sellData,
            label: {
              show: true,
              position: 'top',
              formatter: function (value) {
                if (typeof value.value === 'number' && !isNaN(value.value)) {
                  return value.value + '万元';
                } else {
                  return 'N/A';
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          },
          {
            name: '剩余金额占比',
            type: 'bar',
            data: sellData1,
            label: {
              show: true,
              position: 'top',
              formatter: function (value) {
                if (typeof value.value === 'number' && !isNaN(value.value)) {
                  return value.value + '万元';
                } else {
                  return 'N/A';
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          },
        ]
      };

      this.chart.setOption(option);

    }, prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchDataChart((this.currentPage - 1) * this.perPage);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchDataChart((this.currentPage - 1) * this.perPage);
      }
    }
  },
  props: {
    stockData: {
      type: Array,
      required: true
    },
    agency:{
      type:String,
      required:true
    }
  }
};
</script>

<style>
</style>
